import { usePutHttp } from "../../../../hooks/http/http.hook";

interface IBody {
  endDate: string;
}

interface IResponse {
  campaign: IBody;
}


export function useMakeCampaignLiveHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/brand/campaigns/:campaignId/make-live",
  });
}
